export { default } from './ColorKitPdp';